<template>
  <component
    :is="tag"
    v-bind="$attrs"
    class="main-btn transition__normal"
    :disabled="disabled"
    :class="{
      'main-btn--reversed': reversed,
      'main-btn--danger': danger,
      'main-btn--grey': grey,
      'main-btn--small': small
    }"
    :grey="grey"
  >
    <slot></slot>
    <slot name="icon"></slot>
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    disabled: { type: Boolean, default: false },
    reversed: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    grey: { type: Boolean, default: false },
    tag: { type: String, default: 'button' }
  }
}
</script>

<style lang="scss" scoped>
.main-btn {
  @apply flex items-center text-white justify-center border-1 border-primary outline-none bg-primary;

  &:hover {
    @apply bg-transparent border-primary text-primary;
  }

  &--small {
    @apply h-8;
  }

  &--reversed {
    @apply bg-white border-secondary text-secondary;

    &:hover {
      @apply bg-secondary border-secondary text-white;
    }
  }

  &--danger {
    @apply bg-red-darkest border-none;
  }

  &--grey {
    @apply bg-grey-dark border-none;
  }

  &[disabled]:not([disabled="false"]) {
    @apply opacity-50 cursor-not-allowed pointer-events-none;

    &:hover {
      @apply bg-primary text-white;
    }
  }
}
</style>
